import React from "react";
import { useHotkeys } from "react-hotkeys-hook";
import hotkeys from "hotkeys-js";
import { makeStyles, createStyles } from "@material-ui/core";
// import { ElectronAccessor } from "../../helpers";

/** スタイル定義 */
const useStyles = makeStyles(
  createStyles({
    root: {
      height: "100%",
    },
  })
);

interface Props {
  children: React.ReactNode;
}

/** Rootイベントラッパ */
export function RootEventWrapper(props: Props) {
  const classes = useStyles();

  const { children } = props;

  // [Hotkeys]
  // (参考)
  // https://github.com/JohannesKlauss/react-hotkeys-hook
  // https://libraries.io/npm/hotkeys-js
  // useHotkeys("*", () => {
  //   // '+'キーの指定方法がわからないためキーコードで判定する
  //   if (
  //     hotkeys.control &&
  //     hotkeys.shift &&
  //     hotkeys.getPressedKeyCodes().includes(187)
  //   ) {
  //     ElectronAccessor.zoomIn();
  //   }
  // });
  // useHotkeys("ctrl+0", () => ElectronAccessor.zoomClear());
  // useHotkeys("ctrl+-", () => ElectronAccessor.zoomOut());

  // // [Handlers]
  // const handleWheel = (event: React.WheelEvent) => {
  //   event.stopPropagation();
  //   // console.log(`deltaX:${event.deltaX} deltaY:${event.deltaY} deltaZ:${event.deltaZ}`);
  //   if (event.deltaY > 0 && hotkeys.control) {
  //     ElectronAccessor.zoomOut();
  //   } else if (event.deltaY < 0 && hotkeys.control) {
  //     ElectronAccessor.zoomIn();
  //   }
  // };

  //--------------------
  // コンポーネント
  return (
    // <div className={classes.root} onWheel={handleWheel}>
    <div className={classes.root}>
      {children}
    </div>
  );
}
